/**
 * Labstep
 *
 * @desc ShowEdit component for MolecularWeight
 */

import { fieldMolecularWeight } from 'labstep-web/components/PubChemMetadata/Form/fields';
import { PubChemMetadataFormShowEditGeneric } from 'labstep-web/components/PubChemMetadata/Form/ShowEdit/Generic';
import type React from 'react';
import type { IPubChemMetadataFormShowEditMolecularWeightProps } from './types';

export const PubChemMetadataFormShowEditMolecularWeight: React.FC<
  IPubChemMetadataFormShowEditMolecularWeightProps
> = ({ parent, pubChemMetadata }) => (
  <PubChemMetadataFormShowEditGeneric
    pubChemMetadata={pubChemMetadata}
    parent={parent}
    field={fieldMolecularWeight}
  />
);
